(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["neela-seller-contact"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('neela-seller-contact')) {
    customElements.define('neela-seller-contact', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.generation = 0;
        this.scope = this.closest('.shopify-section');
        this.scope?.addEventListener('shopify:product:select', (event) => this.updateSelection(event), {signal:this.controller.signal});
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.generation++;
      }
      async updateSelection(event) {
        if (event.target.closest('product-card') || event.target.closest('.shopify-section') !== this.scope) return;
        const generation = ++this.generation;
        const link = this.querySelector('.neela-seller__contact');
        link?.removeAttribute('href');
        link?.setAttribute('aria-disabled', 'true');
        try {
          const result = await event.promise;
          if (!this.isConnected || generation !== this.generation) return;
          const replacement = result?.detail?.html?.getElementById(this.id);
          if (!replacement) {
            this.querySelector('.neela-seller__contact')?.setAttribute('hidden', '');
            return;
          }
          this.replaceChildren(...Array.from(replacement.childNodes, (node) => node.cloneNode(true)));
          this.hidden = replacement.hidden;
        } catch {
          if (generation === this.generation) this.querySelector('.neela-seller__contact')?.setAttribute('hidden', '');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
